import { render, staticRenderFns } from "./FollowSellingProfit.vue?vue&type=template&id=50a86565&scoped=true"
import script from "./FollowSellingProfit.vue?vue&type=script&lang=js"
export * from "./FollowSellingProfit.vue?vue&type=script&lang=js"
import style0 from "./FollowSellingProfit.vue?vue&type=style&index=0&id=50a86565&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a86565",
  null
  
)

export default component.exports